/** An asynchronous delay function */
export const delay = (ms: number): Promise<void> => new Promise((res) => setTimeout(res, ms));

/**
 * Generate a random ID, to avoid using `index` as `key`.
 * Converts a random seed to base 36 (numbers & letters),
 * then takes the first 9 chars after decimal.
 */
export const generateId = (): string => `_${Math.random().toString(36).substring(1, 10)}`;

/** Splits each word and capitalises the first letter of each word */
export const capitalise = (value?: string): string => {
  if (!value) {
    return '';
  }

  if (value.includes('_')) {
    return value
      .toLowerCase()
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  return value
    .toLowerCase()
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
